import { render } from "./detail.vue?vue&type=template&id=8f84ad0c&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=8f84ad0c&scoped=true&lang=css"

import exportComponent from "/Users/qiao/KaungSpace/DevSpace/KaungAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f84ad0c"]])

export default __exports__